import { Target } from "lucide-react";
import {
  GoalsParamsSchema,
  defaultGoalsParams,
  type GoalsParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { GoalsWidget } from "./Component.js";

/**
 * Goals — the VSM charter's baseline → target → % change table (VSM-WS10,
 * PB-347). Registered as a first-class widget-kind (schema + registry +
 * data-blind Component) so it can later be placed on the VSM canvas and
 * AI-drafted, and is embedded today by the VSM charter's Goals section.
 *
 * `modes: []` — register-only, exactly as `sipoc` (PB-346). The widget registry
 * has no module-ownership discriminator yet and SOLVE's canvas catalog treats
 * every SQL canvas kind as its own; `["canvas"]` today would leak Goals into the
 * SOLVE `+ Widget` menu / catalog-parity test. PB-197 introduces the VSM canvas
 * host (and the discriminator it needs) and flips this to `["canvas"]`.
 */
export const goalsDef: SqlWidgetDef<GoalsParams> = {
  kind: "goals",
  label: "Goals",
  modes: [],
  singleton: false,
  defaultSize: { w: 560, h: 260 },
  defaultParams: defaultGoalsParams,
  Component: GoalsWidget,
  storage: "sql",
  schema: GoalsParamsSchema,
  accent: "purple",
  icon: Target,
  subtitle: "Baseline → target → % change",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 560, height: 260 },
};

registerWidget(goalsDef);
